import { useEffect, useState } from "react";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import { PiCheck } from "react-icons/pi";
import Search from "../assets/icons/search.svg";
import { AiOutlineEye } from "react-icons/ai";
import {
  getInstitutionCategory,
  getInstitutionType,
  showInstUnderCategory,
} from "../api/services";
import { ThreeDots } from "react-loader-spinner";
import DashboardLayout from "./DashboardLayout";
import { Link } from "react-router-dom";
import Pagination2 from "../components/Pagination2";

const BrochureInstituitions2 = () => {
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  const [showInst, setShowInst] = useState(false);
  const [inst, setInst] = useState("All");

  const [showUni, setShowUni] = useState(false);
  const [university, setUniversity] = useState("All");

  // const [alpha, setAlpha] = useState('All')

  const filterLetter = [];
  const [showFilter, setShowFilter] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const handleInst = (item) => {
    setInst(item.title);
    setSelectedInstitutionType(item.id);
    setUniversity("All");
    // setAlpha('All')
    setShowInst(false);
    setShowFilter(false);
  };

  const handleUniversities = (item) => {
    setUniversity(item.title);
    setSelectedCategory(item.id);
    setShowUni(false);
    // setAlpha('All')
    setShowFilter(false);
  };

  // const alphabets = [
  //   "All",
  //   "A",
  //   "B",
  //   "C",
  //   "D",
  //   "E",
  //   "F",
  //   "G",
  //   "H",
  //   "I",
  //   "J",
  //   "K",
  //   "L",
  //   "M",
  //   "N",
  //   "O",
  //   "P",
  //   "Q",
  //   "R",
  //   "S",
  //   "T",
  //   "U",
  //   "V",
  //   "W",
  //   "X",
  //   "Y",
  //   "Z",
  // ];

  const [instType, setInstTypes] = useState([]);
  const [selectedInstitutionType, setSelectedInstitutionType] = useState(null);

  //   GET INSTITUTION TYPES
  useEffect(() => {
    const fetchInstitutionTypes = async () => {
      try {
        const data = await getInstitutionType();
        setInstTypes(data);
      } catch (error) {
        // setError(error);
        console.log(error, "THis is the error");
      } finally {
        setLoading(false);
      }
    };

    fetchInstitutionTypes();
  }, []);

  //   GET INSTITUTION CATEGORIES
  const [instCategory, setInstCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchInstitutionCategories = async () => {
      try {
        const data = await getInstitutionCategory(selectedInstitutionType);
        setInstCategory(data);
      } catch (error) {
        // setError(error);
        console.log(error, "THis is the error");
      } finally {
        setLoading(false);
      }
    };

    fetchInstitutionCategories();
  }, [selectedInstitutionType]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);

  //   GET INSTITUTIONS UNDER EACH CATEGORIES
  const [institutions, setInstitutions] = useState([]);
  useEffect(() => {
    const fetchInstitutions = async () => {
      try {
        const data = await showInstUnderCategory(
          selectedInstitutionType,
          selectedCategory,
          currentPage,
          setLoading,
          searchTerm
        );
        setInstitutions(data.data);
        setTotalPages(data.last_page); // This is to get the total pages of the data
        // console.log(data?.total, 'SCHOOLS')
      } catch (error) {
        // setError(error);
        console.log(error, "THis is the error");
      } finally {
        setLoading(false);
      }
    };

    fetchInstitutions();
  }, [selectedInstitutionType, selectedCategory, currentPage, searchTerm]);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);
    // setShowFilter(true)
    // const filteredSchools = institutions.filter((item) => item?.title.toLowerCase().includes(searchValue));
    // setFilterLetter(filteredSchools);
    // setInst('All')
    // setUniversity('All')
    // setAlpha('All')
  };

  // const handleAlpha = (alphabet) => {
  //   setInst("All");
  //   setUniversity("All");
  //   if (alphabet === "All") {
  //     setAlpha(alphabet);
  //     setShowFilter(false);
  //   } else if (alphabet !== "All" && university !== "All") {
  //     setAlpha(alphabet);
  //     setShowFilter(true);
  //     const filteredSchools = institutions.filter((item) =>
  //       item.title.toLowerCase().startsWith(alphabet.toLowerCase())
  //     );
  //     setFilterLetter(filteredSchools);
  //   } else if (alphabet !== "All" && university === "All") {
  //     setAlpha(alphabet);
  //     setShowFilter(true);
  //     const filteredSchools = institutions.filter((item) =>
  //       item.title.toLowerCase().startsWith(alphabet.toLowerCase())
  //     );
  //     setFilterLetter(filteredSchools);
  //   }
  // };

  return (
    <DashboardLayout
      brochure="Brochure by institution"
      childTab={11}
      animated={true}
    >
      <div className="flex flex-col items-center justify-start w-full px-5 pb-7 mt-10 md:relative md:px-6 lg:px-7 xl:px-10 xl:pb-10">
        {/*TOP INPUTS* */}
        <div className="flex items-start justify-between w-full flex-wrap md:absolute md:px-6 md:z-10 lg:px-7 xl:px-10">
          {/*INSTITUITION* */}
          <div className="flex flex-col items-start w-[265px] bg-white md:w-[30%] xl:w-[25%]">
            <p className="text-[11px] text-[#101828] font-medium xl:text-sm">
              Institution
            </p>
            <div className="flex flex-col items-center w-full py-[10px] px-3 mt-1 border-[1px] border-[#DDE1E6] rounded-md xl:py-3 xl:px-5 xl:rounded-lg">
              <div
                onClick={() => setShowInst(!showInst)}
                className="flex items-center justify-between w-full cursor-pointer"
              >
                <p className="text-[10px] text-[#101828] font-medium xl:text-sm">
                  {inst}
                </p>
                {showInst ? (
                  <SlArrowUp className="text-xs text-[#808080] ml-5 xl:text-sm" />
                ) : (
                  <SlArrowDown className="text-xs text-[#808080] ml-5 xl:text-sm" />
                )}
              </div>
              {showInst && (
                <div className="w-full">
                  {instType.map((item) => {
                    return (
                      <div
                        key={item.id}
                        onClick={() => handleInst(item)}
                        className="flex items-center justify-start w-full mt-3 cursor-pointer"
                      >
                        <div className="flex items-center justify-center h-[14px] w-[14px] rounded-sm border-[1px] border-[#DDE1E6] xl:h-4 xl:w-4 xl:rounded">
                          {inst === item?.title && <PiCheck />}
                        </div>
                        <p className="text-[10px] text-[#101828] font-normal ml-2 xl:text-sm">
                          {item?.title}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* FILTER INSTITUITION */}
          <div className="flex flex-col items-start mt-4 w-[265px] bg-white md:w-[35%] md:mt-0 xl:w-[42%]">
            <p className="text-[11px] text-[#101828] font-medium xl:text-sm">
              Filter institution by
            </p>
            <div className="flex flex-col items-center w-full py-[10px] px-3 mt-1 border-[1px] border-[#DDE1E6] rounded-md xl:py-3 xl:px-5 xl:rounded-lg">
              <div
                onClick={() => setShowUni(!showUni)}
                className="flex items-center justify-between w-full cursor-pointer"
              >
                <p className="text-[10px] text-[#101828] font-medium xl:text-sm">
                  {university}
                </p>
                {showUni ? (
                  <SlArrowUp className="text-xs text-[#808080] ml-5 xl:text-sm" />
                ) : (
                  <SlArrowDown className="text-xs text-[#808080] ml-5 xl:text-sm" />
                )}
              </div>
              {showUni && (
                <div className="w-full">
                  {instCategory.map((item) => {
                    return (
                      <div
                        key={item.id}
                        onClick={() => handleUniversities(item)}
                        className="flex items-center justify-start w-full mt-3 cursor-pointer"
                      >
                        <div className="flex items-center justify-center h-[14px] w-[14px] rounded-sm border-[1px] border-[#DDE1E6] xl:h-4 xl:w-4 xl:rounded">
                          {university === item?.title && <PiCheck />}
                        </div>
                        <p className="text-[10px] text-[#101828] font-normal ml-2 xl:text-sm">
                          {item?.title}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/*SEARCH*/}
          <div className="flex flex-col items-start mt-4 w-full bg-white md:w-[32%] md:mt-0 xl:w-[30%]">
            <p className="text-[11px] text-[#101828] font-medium xl:text-sm">
              Search
            </p>
            <div className="relative h-9  mt-1 w-full xl:h-11">
              <input
                className={`border-[2px] rounded-md h-full w-full bg-white text-[10px] text-[#101828] font-normal pl-9 outline-[#25A249] 
                                 xl:text-sm xl:pl-12 xl:rounded-lg ${
                                   searchTerm !== ""
                                     ? "border-[#25A249]"
                                     : "border-[#DDE1E6]"
                                 } `}
                placeholder="Search institution name"
                value={searchTerm}
                onChange={handleSearch}
              />
              <img
                className="absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5"
                src={Search}
                alt="search_icon"
              />
            </div>
          </div>
        </div>

        {/* ALPHABETS */}
        {/* <div className='flex items-center justify-start w-full flex-wrap mt-5 md:mt-20 lg:justify-between lg:mt-[85px] xl:mt-28'>
             {alphabets.map((item) => {
              return(
                <div key={item} onClick={()=>handleAlpha(item)} 
                className={`flex items-center justify-center px-[8px] py-1 mr-[6px] my-[2px] cursor-pointer rounded-3xl md:mr-[10px] lg:mx-0
                                                                ${alpha === item && 'border-[1px] border-[#25A249]'}`}>
                   <p className={`text-[11px] font-medium xl:text-sm ${alpha === item ? 'text-[#25A249]' : 'text-[#101828]'}`}>
                      {item}
                   </p>
                </div>
              )
             })}
        </div> */}

        {/* LIST OF INSTITUITIONS */}
        <div className="flex items-center justify-between w-full mt-6 xl:mt-7">
          <p className="text-[12px] font-semibold text-[#53545C] md:text-[13px] xl:text-base">
            List of institutions
          </p>

          <div className="flex items-center justify-end">
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              Show
            </p>
            <div className="flex items-center justify-between px-[6px] py-[3px] border-[1px] border-[#DDE1E6] rounded mx-[6px] md:mx-2 xl:mx-3">
              <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                15
              </p>
              <SlArrowDown className="text-[7px] ml-[10px] xl:ml-[14px] xl:text-[9px]" />
            </div>
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              entries
            </p>
          </div>
        </div>

        {/* INSTTUITIONS */}
        <div className="flex flex-col items-start justify-start w-full min-h-60 mt-3 mb-4 md:mb-5 md:min-h-96 lg:mt-2 lg:min-h-[450px] xl:mt-2.5 xl:mb-6 xl:min-h-[475px]">
          {/* DEFAULT SCHOOLS */}
          {university === "All" &&
            inst === "All" &&
            !showFilter &&
            !loading &&
            institutions.map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-start w-full pt-6 border-b-[1px] border-[#DDE1E6] pb-3 px-2 hover:bg-gray-200 md:flex-row md:items-start 
                                          md:w-full md:pt-10 lg:px-3 lg:items-center lg:pt-8 xl:pb-4"
              >
                <p className="text-[11px] font-medium text-[#53545C] w-[90%] md:text-[11px] xl:text-[13px]">
                  {item.title}
                </p>

                <Link
                  to={`/brochure-courses?id=${item?.id}&school=${item?.title}`}
                  className="flex items-center justify-between px-5 w-[130px] h-8 mt-3 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3 
                             md:w-[125px] md:px-3 xl:w-[145px] xl:px-[15px] xl:h-9"
                >
                  <p className="text-[10px] font-medium text-[#ffffff] md:text-[10px] xl:text-[13px]">
                    View Courses
                  </p>
                  <AiOutlineEye className="text-white xl:text-lg" />
                </Link>
              </div>
            ))}

          {/* SHOWS LISTS OF SCHOOLS UNDER INSTUTUITIONS BY DEFAULT */}
          {university === "All" &&
            inst !== "All" &&
            !showFilter &&
            !loading &&
            institutions.map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-start w-full pt-6 border-b-[1px] border-[#DDE1E6] pb-3 px-2 hover:bg-gray-200 md:flex-row md:items-start 
                                          md:w-full md:pt-10 lg:px-3 lg:items-center lg:pt-8 xl:pb-4"
              >
                <p className="text-[11px] font-medium text-[#53545C] w-[90%] md:text-[11px] xl:text-[13px]">
                  {item.title}
                </p>

                <Link
                  to={`/brochure-courses?id=${item?.id}&school=${item?.title}`}
                  className="flex items-center justify-between px-5 w-[130px] h-8 mt-3 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3 
                             md:w-[125px] md:px-3 xl:w-[145px] xl:px-[15px] xl:h-9"
                >
                  <p className="text-[10px] font-medium text-[#ffffff] md:text-[10px] xl:text-[13px]">
                    View Courses
                  </p>
                  <AiOutlineEye className="text-white xl:text-lg" />
                </Link>
              </div>
            ))}

          {/* SHOWS LISTS OF SCHOOLS UNDER CATEGORY */}
          {university !== "All" &&
            !showFilter &&
            !loading &&
            institutions.map((item) => {
              return (
                <div
                  key={item.id}
                  className="flex flex-col items-start w-full pt-6 border-b-[1px] border-[#DDE1E6] pb-3 px-2 hover:bg-gray-200 md:flex-row md:items-start 
                                          md:w-full md:pt-10 lg:px-3 lg:items-center lg:pt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[90%] md:text-[11px] xl:text-[13px]">
                    {item.title}
                  </p>

                  <Link
                    to={`/brochure-courses?id=${item?.id}&school=${item?.title}`}
                    className="flex items-center justify-between px-5 w-[130px] h-8 mt-3 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3 
                             md:w-[125px] md:px-3 xl:w-[145px] xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View Courses
                    </p>
                    <AiOutlineEye className="text-white xl:text-lg" />
                  </Link>
                </div>
              );
            })}

          {/* FILTER SCHOOLS BY ALPHABETS AND SEARCH SCHOOLS */}
          {showFilter &&
            !loading &&
            filterLetter.map((item) => {
              return (
                <div
                  key={item.id}
                  className="flex flex-col items-start w-full pt-6 border-b-[1px] border-[#DDE1E6] pb-3 px-2 hover:bg-gray-200 md:flex-row md:items-start 
                                          md:w-full md:pt-10 lg:px-3 lg:items-center lg:pt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[90%] md:text-[11px] xl:text-[13px]">
                    {item.title}
                  </p>

                  <Link
                    to={`/brochure-courses?id=${item?.id}&school=${item?.title}`}
                    className="flex items-center justify-between px-5 w-[130px] h-8 mt-3 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3 
                             md:w-[125px] md:px-3 xl:w-[145px] xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View Courses
                    </p>
                    <AiOutlineEye className="text-white xl:text-lg" />
                  </Link>
                </div>
              );
            })}

          {/* FILTERED SCHOOLS NOT FOUND */}
          {(filterLetter.length === 0 && showFilter) |
          (institutions?.length === 0 && !loading) ? (
            <div className="flex items-center justify-center w-full h-full mt-5">
              <p className="text-[#25A249] font-medium">
                No institution found...
              </p>
            </div>
          ) : null}

          {/* LOADING STATE */}
          {loading && (
            <div className="flex items-start justify-center w-full h-full">
              <ThreeDots color="#25A249" />
            </div>
          )}
        </div>

        {searchTerm === "" && (
          <Pagination2
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            //  loading={loading}
          />
        )}
      </div>
    </DashboardLayout>
  );
};

export default BrochureInstituitions2;
